/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Files_Actions_RefreshInputs */

const es_settings_files_actions_refresh = /** @type {(inputs: Settings_Files_Actions_RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar`)
};

const en_settings_files_actions_refresh = /** @type {(inputs: Settings_Files_Actions_RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refresh`)
};

/**
* | output |
* | --- |
* | "Refresh" |
*
* @param {Settings_Files_Actions_RefreshInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_files_actions_refresh = /** @type {((inputs?: Settings_Files_Actions_RefreshInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Files_Actions_RefreshInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_files_actions_refresh(inputs)
	return en_settings_files_actions_refresh(inputs)
});
export { settings_files_actions_refresh as "settings.files.actions.refresh" }